/** README
 *  >>> 提供一些辅助功能或方法
 * 
 */

import { cloneDeep } from "@/utils";
import { getElecPriceSegmentColor } from '@/utils/colorHelper/index.js';

const $str = window.$str;


export class Helper {
  constructor(gwElecPrice) {
    this.priceKeyList = [
      ...['inSharpPrice', 'inPeakPrice', 'inFlatPrice', 'inValleyPrice', 'inDeepValleyPrice'],
      ...['outSharpPrice', 'outPeakPrice', 'outFlatPrice', 'outValleyPrice', 'outDeepValleyPrice'],
    ]
    // 时段名称的下拉选项
    this.sigmentOptions = [
      {
        value: 'sharp',
        label: $str.getKey('收益管理/尖峰时段'),
      },
      {
        value: 'peak',
        label: $str.getKey('收益管理/高峰时段'),
      },
      {
        value: 'flat',
        label: $str.getKey('收益管理/平时段'),
      },
      {
        value: 'valley',
        label: $str.getKey('收益管理/低谷时段'),
      },
      {
        value: 'deepValley',
        // value: 'deep',
        label: $str.getKey('收益管理/深谷时段'),
      },
    ],
    this.initHelper();

  }



  initHelper() {
    this.refreshGwPriceInfo();
    this.INIT_GW_SAME();
    this.INIT_GW_DIFF();
    this.INIT_CUSTOM_SAME();
    this.INIT_CUSTOM_DIFF();
  }

  refreshHelperByGwInfo(gwElecPrice) {
    this.refreshGwPriceInfo(gwElecPrice);
    this.INIT_GW_SAME();
    this.INIT_GW_DIFF();
    this.INIT_CUSTOM_SAME();
    this.INIT_CUSTOM_DIFF();
  }


  /** 初始化：helper中保存的国网电价 */
  refreshGwPriceInfo(gwElecPrice) {
    const data = {};
    // 初始化：各时段的国网电价-默认为0
    this.priceKeyList.forEach(k => { data[k] = 0; });
    // 更新：如果参数携带了真实的国网电价，更新默认值
    if (gwElecPrice) {
      this.priceKeyList.forEach(k => { data[k] = gwElecPrice[k] ?? 0; });
    }
    this.gwElecPrice = data;
  }

  /**
   * 初始化数据结构：GW_SAME
   * >>> 按国网电价-充放电电价一致-对应的数据结构
   * >>> 基于国网电价初始化 this.gwElecPrice
   */
  INIT_GW_SAME() {
    const data = [
      {
        name: $str.getKey('收益管理/尖峰时段'),
        key: 'sharpPrice',
        value: 0,
        color: getElecPriceSegmentColor('sharp'),
      },
      {
        name: $str.getKey('收益管理/高峰时段'),
        key: 'peakPrice',
        value: 0,
        color: getElecPriceSegmentColor('peak'),
      },
      {
        name: $str.getKey('收益管理/平时段'),
        key: 'flatPrice',
        value: 0,
        color: getElecPriceSegmentColor('flat'),
      },
      {
        name: $str.getKey('收益管理/低谷时段'),
        key: 'valleyPrice',
        value: 0,
        color: getElecPriceSegmentColor('valley'),
      },
      {
        name: $str.getKey('收益管理/深谷时段'),
        key: 'deepValleyPrice',
        value: 0,
        color: getElecPriceSegmentColor('deepValley'),
      },
    ]

    if (this.gwElecPrice) {
      data.forEach(it => {
        const key = 'in' + it.key.charAt(0).toUpperCase() + it.key.slice(1);
        it.value = this.gwElecPrice[key] ?? 0;
      })
    }

    this.GW_SAME = data;
  }

  /**
   * 刷新数据结构：GW_SAME
   * >>> 复用 | 编辑 >>> 回显内容
   * @param {*} cfg 
   */
  refresh_GW_SAME(cfg) {
    if (cfg) {
      this.GW_SAME.forEach(it => {
        it.value = cfg[it.key] ?? 0;
      })
    }
  }

  /**
   * 初始化数据结构：GW_DIFF
   * >>> 按国网电价-充放电电价不一致-对应的数据结构
   */
  INIT_GW_DIFF() {
    const data = {
      in: [
        {
          name: $str.getKey('收益管理/尖峰时段'),
          key: 'inSharpPrice',
          value: 0,
          color: getElecPriceSegmentColor('sharp'),
        },
        {
          name: $str.getKey('收益管理/高峰时段'),
          key: 'inPeakPrice',
          value: 0,
          color: getElecPriceSegmentColor('peak'),
        },
        {
          name: $str.getKey('收益管理/平时段'),
          key: 'inFlatPrice',
          value: 0,
          color: getElecPriceSegmentColor('flat'),
        },
        {
          name: $str.getKey('收益管理/低谷时段'),
          key: 'inValleyPrice',
          value: 0,
          color: getElecPriceSegmentColor('valley'),
        },
        {
          name: $str.getKey('收益管理/深谷时段'),
          key: 'inDeepValleyPrice',
          value: 0,
          color: getElecPriceSegmentColor('deepValley'),
        },
      ],
      out: [
        {
          name: $str.getKey('收益管理/尖峰时段'),
          key: 'outSharpPrice',
          value: 0,
          color: getElecPriceSegmentColor('sharp'),
        },
        {
          name: $str.getKey('收益管理/高峰时段'),
          key: 'outPeakPrice',
          value: 0,
          color: getElecPriceSegmentColor('peak'),
        },
        {
          name: $str.getKey('收益管理/平时段'),
          key: 'outFlatPrice',
          value: 0,
          color: getElecPriceSegmentColor('flat'),
        },
        {
          name: $str.getKey('收益管理/低谷时段'),
          key: 'outValleyPrice',
          value: 0,
          color: getElecPriceSegmentColor('valley'),
        },
        {
          name: $str.getKey('收益管理/深谷时段'),
          key: 'outDeepValleyPrice',
          value: 0,
          color: getElecPriceSegmentColor('deepValley'),
        },
      ],
    }

    if (this.gwElecPrice) {
      data.in.forEach(it => { it.value = this.gwElecPrice[it.key] ?? 0; });
      data.out.forEach(it => { it.value = this.gwElecPrice[it.key] ?? 0; });
    }

    this.GW_DIFF = data;
  }

  /**
   * 刷新数据结构：GW_DIFF
   * >>> 复用 | 编辑 >>> 回显内容
   * @param {*} cfg 
   */
  refresh_GW_DIFF(cfg) {
    if (cfg) {
      this.GW_DIFF.in.forEach(it => { it.value = cfg[it.key] ?? 0; });
      this.GW_DIFF.out.forEach(it => { it.value = cfg[it.key] ?? 0; });
    }
  }



  /**
   * 初始化数据结构：CUSTOM_SAME
   * >>> 自定义电价-充放时段一致-充放电价一致
   */
  INIT_CUSTOM_SAME() {
    const data = []
    const defaultItem = this.createItem('CUSTOM_SAME');
    data.push(defaultItem);

    this.CUSTOM_SAME = data;
  }

  /**
   * 刷新数据结构：CUSTOM_SAME
   * >>> 复用 | 编辑 >>> 回显内容
   * @param {*} originList 
   */
  refresh_CUSTOM_SAME(originList) {
    const data = [];
    if (Array.isArray(originList) && originList.length > 0) {
      originList.forEach(it => {
        const item = this.createItem('CUSTOM_SAME');
        item.startTime = it.startTime;
        item.endTime = it.endTime;
        item.key = it.key; // 注意保持key和下来选项的value字段保持一致
        item.price = it.price;
        data.push(item);
      })
      this.CUSTOM_SAME = data;
    } else {
      this.INIT_CUSTOM_SAME();
    }
  }


  /**
   * 初始化数据结构：CUSTOM_DIFF
   * >>> 自定义电价-充放电价不同
   */
  INIT_CUSTOM_DIFF() {
    const data = []
    const defaultItem = this.createItem('CUSTOM_DIFF');
    data.push(defaultItem);

    this.CUSTOM_DIFF = data;
  }


  /**
   * 刷新数据结构：CUSTOM_DIFF
   * >>> 复用 | 编辑 >>> 回显内容
   * @param {*} originList 
   */
  refresh_CUSTOM_DIFF(originList) {
    const data = [];
    if (Array.isArray(originList) && originList.length > 0) {
      originList.forEach(it => {
        const item = this.createItem('CUSTOM_DIFF');
        item.startTime = it.startTime;
        item.endTime = it.endTime;
        item.key = it.key; // 注意保持key和下来选项的value字段保持一致
        item.inPrice = it.inPrice;
        item.outPrice = it.outPrice;
        data.push(item);
      })
      this.CUSTOM_DIFF = data;
    } else {
      this.INIT_CUSTOM_DIFF();
    }
  }


  /**
   * 创建一项Item
   * @param {*} type 
   * @returns 
   */
  createItem(type) {
    if (type === 'CUSTOM_SAME') {
      return {
        startTime: '',
        endTime: '',
        key: '',
        price: 0,
      }
    } else if (type === 'CUSTOM_DIFF') {
      return {
        startTime: '',
        endTime: '',
        key: '',
        inPrice: 0,
        outPrice: 0,
      }
    } else {
      console.error($str.getKey('收益管理/调用 createItem 时，必须传入正确的type！'))
    }
  }




}










